import { useLocation } from 'react-router-dom';

const useUpdatePageMeta = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const faviconLink = document.getElementById('favicon');

  if (pathname.includes('builder') || pathname.includes('flows')) {
    document.title = 'Final Build';
    faviconLink?.setAttribute('href', '/Build.svg');
  } else if (pathname.includes('launcher')) {
    document.title = 'Final Scale';
    faviconLink?.setAttribute('href', '/Scale.svg');
  } else if (pathname.includes('login')) {
    document.title = 'Final Scale';
    faviconLink?.setAttribute('href', '/Scale.svg');
  } else {
    faviconLink?.setAttribute('href', '/Scale.svg');
    document.title = 'Final Scale';
  }
};

export default useUpdatePageMeta;
